import React, { useState, useRef, useEffect } from "react"
import axios from "axios"
import { useNavigate } from 'react-router-dom';
import Swal from "sweetalert2"

const colors = [
  "#16a34a",
  "#2563eb",
  "#dc2626",
  "#ca8a04",
  "#9333ea",
  "#ea580c"
]

const CreateZone = () => {

  const imageRef = useRef(null)

  /* GENERAL */

  const [templateName, setTemplateName] = useState("")
  const [zoneName, setZoneName] = useState("")
  const [zoneImageUrl, setZoneImageUrl] = useState("")
  const [activeDivision, setActiveDivision] = useState(null)
  const [zoomLevel, setZoomLevel] = useState(1)
  const [blockRows, setBlockRows] = useState(5)
  const [blockCols, setBlockCols] = useState(10)
  const [pan, setPan] = useState({ x: 0, y: 0 })
  const [isPanning, setIsPanning] = useState(false)
  const [curveSeats, setCurveSeats] = useState(20)
  const [curveRows, setCurveRows] = useState(5)
  const [curveRadius, setCurveRadius] = useState(0.2)
  const [curveSpacing, setCurveSpacing] = useState(0.05)
  const [curveAngle, setCurveAngle] = useState(Math.PI) // 180°
  const [snapToGrid, setSnapToGrid] = useState(false)
  const [dragStart, setDragStart] = useState(null)
  const [curveRotation, setCurveRotation] = useState(0)
  const [openSection, setOpenSection] = useState(null)
  const gridSize = 20
  const navigate = useNavigate();

  /* DIVISION */

  const [divisionName, setDivisionName] = useState("")
  const [divisionType, setDivisionType] = useState("seats")
  const [generalSpace, setGeneralSpace] = useState(0)
  const [divisionImageUrl, setDivisionImageUrl] = useState("")
  const [drawingPath, setDrawingPath] = useState([])
  const [isDrawing, setIsDrawing] = useState(false)
  const [currentSeats, setCurrentSeats] = useState([])
  const [divisions, setDivisions] = useState([])
  const [draftSeats, setDraftSeats] = useState([])
  const [shiftMode, setShiftMode] = useState(false)
  const [row, setRow] = useState(1)

  /* GENERATOR */
  const [verticalDirection, setVerticalDirection] = useState("topToBottom")
  const [rowStart, setRowStart] = useState(1)
  const [rowEnd, setRowEnd] = useState(5)
  const [seatsPerRow, setSeatsPerRow] = useState(10)
  const [orientation, setOrientation] = useState("horizontal")
  const [seatSpacing, setSeatSpacing] = useState(0.07)
  const [rowSpacing, setRowSpacing] = useState(0.025)
  const [drawSeatSpacing, setDrawSeatSpacing] = useState(0.0206)
  const [rowsOrientation, setRowsOrientation] = useState("horizontal")
  const [rowsVerticalDirection, setRowsVerticalDirection] = useState("topToBottom")
  const [seatNumberMode, setSeatNumberMode] = useState("normal")


  /* DRAG */
  const containerRef = useRef(null)
  const [draggingSeat, setDraggingSeat] = useState(null)
  const [rowDrawStart, setRowDrawStart] = useState(null)
  const lastDrawPointRef = useRef(null)

  /* COLORS */

  const divisionColorMap = useRef({})

  const getDivisionColor = (division) => {

    if (!divisionColorMap.current[division]) {

      const index = Object.keys(divisionColorMap.current).length
      divisionColorMap.current[division] = colors[index % colors.length]

    }

    return divisionColorMap.current[division]

  }

  ///borrar asientos ///

  const clearCurrentDivision = () => {
    setCurrentSeats([])
    setDraftSeats([])
  }

  useEffect(() => {

    const handleKeyDown = (e) => {

      if (e.key === "Delete") {

        const confirmDelete = window.confirm(
          "¿Borrar todos los asientos de esta división?"
        )

        if (confirmDelete) {
          clearCurrentDivision()
        }

      }

    }

    window.addEventListener("keydown", handleKeyDown)

    return () => {
      window.removeEventListener("keydown", handleKeyDown)
    }

  }, [])

  ///ASIENTOS EN INTERVALOS///

  const getInterleavedSeatNumber = (index, total) => {

    const half = Math.floor(total / 2)

    if (index < half) {
      return total - (index * 2)
    }

    return ((index - half) * 2) + 1
  }

  /* AUTOSAVE */

  useEffect(() => {
    localStorage.setItem("seatEditor", JSON.stringify(currentSeats))
  }, [currentSeats])

  useEffect(() => {

    const saved = localStorage.getItem("seatEditor")

    if (saved) {
      setCurrentSeats(JSON.parse(saved))
    }

  }, [])


  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Enter") {
        setRow(prev => prev + 1)
      }
    }

    window.addEventListener("keydown", handleKeyDown)

    return () => {
      window.removeEventListener("keydown", handleKeyDown)
    }
  }, [])


  useEffect(() => {

    const handleKeyDown = (e) => {

      if (e.key === "Shift") {
        setShiftMode(true)
      }

    }

    const handleKeyUp = (e) => {

      if (e.key === "Shift") {

        setShiftMode(false)
        setIsDrawing(false)

        // 🔥 CONFIRMAR ASIENTOS GRISES
        if (draftSeats.length > 0) {

          setCurrentSeats(prev => [
            ...prev,
            ...draftSeats
          ])

          setDraftSeats([])

        }

      }

    }

    window.addEventListener("keydown", handleKeyDown)
    window.addEventListener("keyup", handleKeyUp)

    return () => {

      window.removeEventListener("keydown", handleKeyDown)
      window.removeEventListener("keyup", handleKeyUp)

    }

  }, [draftSeats])


  useEffect(() => {

  }, [blockRows])

  useEffect(() => {

  }, [blockCols])

  /// GENERAR BLOCKES DE ASIENTOS///
  const generateBlock = (originX, originY) => {
    if (!imageRef.current) return

    const spacingX = seatSpacing
    const spacingY = rowSpacing

    const newSeats = []

    const rows = Number(blockRows) || 0
    const cols = Number(blockCols) || 0

    for (let r = 0; r < rows; r++) {
      for (let c = 0; c < cols; c++) {

        const x =
          orientation === "horizontal"
            ? originX + (c * spacingX)
            : originX + (r * spacingX)

        const y =
          orientation === "horizontal"
            ? originY + (r * spacingY)
            : originY + (c * spacingY)

        newSeats.push({
          id:
            seatNumberMode === "interleaved"
              ? getInterleavedSeatNumber(c, cols)
              : (
                orientation === "vertical"
                  ? (
                    verticalDirection === "bottomToTop"
                      ? cols - c
                      : c + 1
                  )
                  : c + 1
              ),

          row: row + r,
          division: divisionName,
          x,
          y
        })
      }
    }

    setCurrentSeats(prev => [...prev, ...newSeats])
  }

  /* AUTO SEAT ID */

  const getNextSeatId = (division, row) => {

    const seats = currentSeats.filter(
      s => s.division === division && s.row === row
    )

    if (seats.length === 0) return 1

    return Math.max(...seats.map(s => s.id)) + 1

  }

  //obtener tamaño real de la imagen por url///
  const getImageSize = (url) => {
    return new Promise((resolve) => {
      const img = new Image()

      img.onload = () => {
        resolve({
          width: img.naturalWidth,
          height: img.naturalHeight
        })
      }

      img.onerror = () => {
        console.warn("Imagen falló:", url)
        resolve({ width: null, height: null })
      }

      img.src = url
    })
  }

  /* MAP CLICK */

  const handleMapClick = (e) => {

    if (shiftMode) return

    if (!containerRef.current || !imageRef.current) return
    if (isPanning) return

    const rect = containerRef.current.getBoundingClientRect()

    let x = e.clientX - rect.left
    let y = e.clientY - rect.top

    // compensar pan
    x -= pan.x
    y -= pan.y

    // compensar zoom
    x /= zoomLevel
    y /= zoomLevel

    const img = imageRef.current

    const normalizedX = x / img.offsetWidth
    const normalizedY = y / img.offsetHeight

    if (e.ctrlKey && e.shiftKey) {
      generateCurve(normalizedX, normalizedY)
      return
    }



    /* NORMAL CLICK */
    if (e.ctrlKey) {
      generateBlock(normalizedX, normalizedY)
      return
    }
 const nextId = getNextSeatId(divisionName, row)



setCurrentSeats(prev => [
  ...prev,
  {
    id: nextId,
    row,
    division: divisionName,
    x: normalizedX,
    y: normalizedY
  }
])
  }

  /* DELETE */

  const handleDeleteSeat = (index, e) => {
    e.preventDefault()
    setCurrentSeats(prev => prev.filter((_, i) => i !== index))
  }

  /* DRAG */

  const handleMouseDown = (e) => {
    // 🖐️ PAN
    if (e.button === 1) {
      setIsPanning(true)
      return
    }

    // ✏️ SHIFT DRAW
    if (shiftMode && e.button === 0 && containerRef.current && imageRef.current) {
      const rect = containerRef.current.getBoundingClientRect()

      let x = e.clientX - rect.left
      let y = e.clientY - rect.top

      x -= pan.x
      y -= pan.y
      x /= zoomLevel
      y /= zoomLevel

      const img = imageRef.current
      const normalizedX = x / img.offsetWidth
      const normalizedY = y / img.offsetHeight

      setIsDrawing(true)

      // Guardamos el punto de inicio exacto
      lastDrawPointRef.current = {
        startX: normalizedX,
        startY: normalizedY,
        currentX: normalizedX,
        currentY: normalizedY
      }

      // 🔥 CREAR EL PRIMER ASIENTO DE FORMA INMEDIATA (Igual al click individual)
      const currentCount = currentSeats.filter(
        s => s.division === divisionName && s.row === row
      ).length;

      setDraftSeats([
        {
          id: currentCount + 1,
          row,
          division: divisionName,
          x: normalizedX,
          y: normalizedY
        }
      ]);

      return
    }
  }

  const handleMouseMove = (e) => {

  if (isDrawing && containerRef.current && imageRef.current) {

    const drawPoint = lastDrawPointRef.current
    if (!drawPoint) return

    const rect = containerRef.current.getBoundingClientRect()

    let x = e.clientX - rect.left
    let y = e.clientY - rect.top

    x -= pan.x
    y -= pan.y

    x /= zoomLevel
    y /= zoomLevel

    const img = imageRef.current

    if (!img.offsetWidth || !img.offsetHeight) return

    let mouseX = x / img.offsetWidth
    let mouseY = y / img.offsetHeight

    // EJE DOMINANTE
    const diffX = Math.abs(mouseX - drawPoint.startX)
    const diffY = Math.abs(mouseY - drawPoint.startY)

    const isHorizontal = diffX >= diffY

    if (isHorizontal) {
      mouseY = drawPoint.startY
    } else {
      mouseX = drawPoint.startX
    }

    const dx = mouseX - drawPoint.startX
    const dy = mouseY - drawPoint.startY

    const totalDistance = Math.sqrt(
      dx * dx + dy * dy
    )

    if (totalDistance === 0) return

    const dirX = dx / totalDistance
    const dirY = dy / totalDistance

    const currentCount = currentSeats.filter(
      s =>
        s.division === divisionName &&
        s.row === row
    ).length

    const previewSeats = []

    let i = 0
    let dist = 0

    while (dist <= totalDistance) {

      const seatX =
        drawPoint.startX + dirX * dist

      const seatY =
        drawPoint.startY + dirY * dist

      previewSeats.push({
        id: currentCount + i + 1,
        row,
        division: divisionName,
        x: seatX,
        y: seatY
      })

      i++

      dist = i * drawSeatSpacing
    }

 
    previewSeats.forEach((seat, index) => {

      if (index === 0) {

      
        return
      }

      const previous = previewSeats[index - 1]

      const deltaX =
        seat.x - previous.x

      const deltaY =
        seat.y - previous.y

      const distance = Math.sqrt(
        deltaX * deltaX +
        deltaY * deltaY
      )

    })

   
    setDraftSeats(previewSeats)

    return
  }

  // PAN
  if (!isPanning) return

  setPan(prev => ({
    x: prev.x + e.movementX,
    y: prev.y + e.movementY
  }))
}

  const handleMouseUp = () => {

    setDraggingSeat(null)
    setIsPanning(false)
    setDragStart(null)

    // 🔥 TERMINAR SOLO EL TRAZO
    if (isDrawing) {

      setIsDrawing(false)

    }

  }


  const blockRowsRef = useRef(blockRows)
  const blockColsRef = useRef(blockCols)

  useEffect(() => {
    blockRowsRef.current = blockRows
  }, [blockRows])

  useEffect(() => {
    blockColsRef.current = blockCols
  }, [blockCols])

  /* GENERATOR */

  const generateRows = () => {
    if (!imageRef.current) return

    const newSeats = []

    const rows = (rowEnd - rowStart) + 1
    const cols = Number(seatsPerRow) || 0

    const startX = 0.2
    const startY = 0.2

    const spacingX = seatSpacing
    const spacingY = rowSpacing

    for (let r = 0; r < rows; r++) {
      for (let c = 0; c < cols; c++) {

        const x =
          rowsOrientation === "horizontal"
            ? startX + (c * spacingX)
            : startX + (r * spacingX)

        const y =
          rowsOrientation === "horizontal"
            ? startY + (r * spacingY)
            : startY + (c * spacingY)

        newSeats.push({
          id:
            seatNumberMode === "interleaved"
              ? getInterleavedSeatNumber(c, cols)
              : (
                rowsOrientation === "vertical"
                  ? (
                    rowsVerticalDirection === "bottomToTop"
                      ? cols - c
                      : c + 1
                  )
                  : c + 1
              ),

          row: r + 1,
          division: divisionName,
          x,
          y
        })
      }
    }

    setCurrentSeats(prev => [...prev, ...newSeats])
  }


  /* FINISH DIVISION */

  const finishDivision = () => {

    if (!divisionName) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Nombre de division requerido",
        confirmButtonText: "Cerrar",
        customClass: {
          container: "my-swal"
        }
      })
      return
    }

    // DIVISION GENERAL SIN ASIENTOS
    if (divisionType === "general") {

      if (!generalSpace || Number(generalSpace) <= 0) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "La capacidad de la división debe ser mayor a 0",
          confirmButtonText: "Cerrar",
          customClass: {
            container: "my-swal"
          }
        })
        return
      }

      setDivisions(prev => [
        ...prev,
        {
          name: divisionName,
          image: divisionImageUrl,
          type: "general",
          space: Number(generalSpace)
        }
      ])

    } else {

      // DIVISION CON ASIENTOS
      if (currentSeats.length === 0) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Falta agregar asientos",
          confirmButtonText: "Cerrar",
          customClass: {
            container: "my-swal"
          }
        })
        return
      }

      setDivisions(prev => [
        ...prev,
        {
          name: divisionName,
          image: divisionImageUrl,
          type: "seats",
          seats: currentSeats
        }
      ])

    }

    setCurrentSeats([])
    setDivisionName("")
    setDivisionImageUrl("")
    setGeneralSpace(0)
    setDivisionType("seats")
    setRow(() => 1)

  }

  /* CREATE TEMPLATE */

  const buildRows = (seats) => {

    const rows = {}

    seats.forEach(seat => {

      if (!rows[seat.row]) {
        rows[seat.row] = {
          row: seat.row,
          rowPrice: 100,
          seats: []
        }
      }

      rows[seat.row].seats.push({
        id: Number(seat.id),
        x: seat.x,
        y: seat.y,
        taken: false
      })

    })

    return Object.values(rows)

  }

  const handleCreateTemplate = async () => {

    try {

      let zoneWidth = null
      let zoneHeight = null

      if (zoneImageUrl) {
        const size = await getImageSize(zoneImageUrl)
        zoneWidth = size.width
        zoneHeight = size.height
      }

      const location = []

      for (const div of divisions) {

        let divWidth = null
        let divHeight = null

        if (div.image) {
          const size = await getImageSize(div.image)
          divWidth = size.width
          divHeight = size.height
        }

        if (div.type === "general") {

          location.push({

            division: div.name,
            generalPrice: 100,
            space: div.space,
            occupied: 0

          })

        } else {

          location.push({

            division: div.name,
            divisionImageUrl: div.image || null,
            divisionImageWidth: divWidth,
            divisionImageHeight: divHeight,
            generalPrice: 100,

            rows: buildRows(div.seats)

          })

        }

      }

      await axios.post("/templates", {

        templateName,
        zoneName,
        zoneImageUrl,
        zoneImageWidth: zoneWidth,
        zoneImageHeight: zoneHeight,
        location

      })

      Swal.fire({
        icon: "success",
        title: "Template guardado",
        text: "Se creó correctamente",
        confirmButtonText: "Aceptar",
        customClass: {
          container: "my-swal"
        }
      })

    } catch (err) {

      console.error(err)
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Error guardando template",
        confirmButtonText: "Cerrar",
        customClass: {
          container: "my-swal"
        }
      })


    }

  }

  /* RENDER */
  const Section = ({ title, name, openSection, setOpenSection, children }) => {
    const isOpen = openSection === name

    return (
      <div className="border rounded">
        <div
          className="cursor-pointer bg-gray-200 hover:bg-gray-300 p-2 flex justify-between items-center"
          onClick={() => setOpenSection(isOpen ? null : name)}
        >
          <span className="font-bold">{title}</span>
          <span className={isOpen ? "rotate-90" : ""}>▶</span>
        </div>

        <div
          style={{
            maxHeight: isOpen ? "9999px" : "0px",
            transition: "max-height 0.3s ease",
            overflow: "hidden"
          }}
        >
          <div className="p-2 space-y-2">
            {children}
          </div>
        </div>
      </div>
    )
  }

  return (
    <div
      className="
      fixed inset-0
      text-black
      flex flex-col
      p-2 md:p-4
      overflow-hidden
      bg-[rgba(29,81,150,0.43)]
      backdrop-blur-md
    "
      style={{ zIndex: 9999999 }}
    >

      <div className="flex items-center justify-center gap-4 mb-3 md:mb-4 relative">
        <button
          onClick={() => navigate("/admin/Templates")}
          className="absolute left-0 flex items-center gap-2 text-white/70 hover:text-white transition-all duration-200 text-sm md:text-base"
        >
          <span className="text-lg">←</span>
          Volver al panel de admin
        </button>

        <h2 className="text-2xl md:text-3xl font-bold text-center">
          Creador de Templates
        </h2>
      </div>

      <div className="flex flex-col md:flex-row flex-1 gap-4 overflow-hidden md:overflow-hidden overflow-auto">

        {/* PANEL */}

        <div
          className="
          w-full md:w-1/3
          max-h-[40vh]
          md:max-h-full
          border border-white/20
          rounded-2xl
          p-4
          space-y-4
          overflow-y-auto
          bg-white/5
          backdrop-blur-md
          shadow-xl
        "
        >

          <label className="font-semibold">Nombre del Template</label>

          <input
            className="
            w-full
            p-2
            rounded-lg
            bg-[#608CC4]
            border border-white/30
            text-white
            placeholder-white/70
            focus:outline-none
            focus:ring-2
            focus:ring-blue-400
            transition
          "
            value={templateName}
            onChange={e => setTemplateName(e.target.value)}
          />

          <label className="font-semibold">Nombre de Zona</label>

          <input
            className="
            w-full
            p-2
            rounded-lg
            bg-[#608CC4]
            border border-white/30
            text-white
            focus:outline-none
            focus:ring-2
            focus:ring-blue-400
          "
            value={zoneName}
            onChange={e => setZoneName(e.target.value)}
          />

          <hr className="border-white/20" />

          <label className="font-semibold">Nombre de Division</label>

          <input
            className="
            w-full
            p-2
            rounded-lg
            bg-[#608CC4]
            border border-white/30
            text-white
            focus:outline-none
            focus:ring-2
            focus:ring-blue-400
          "
            value={divisionName}
            onChange={e => setDivisionName(e.target.value)}
          />

          <label className="font-semibold">Tipo de División</label>

          <select
            className="
            w-full
            p-2
            rounded-lg
            bg-[#608CC4]
            border border-white/30
            text-white
            "
            value={divisionType}
            onChange={e => setDivisionType(e.target.value)}
          >
            <option value="seats">Con asientos</option>
            <option value="general">General / Sin asientos</option>
          </select>

          {divisionType === "general" && (
            <>
              <label className="font-semibold">Capacidad de lugares</label>

              <input
                type="number"
                min="1"
                className="
                w-full
                p-2
                rounded-lg
                bg-[#608CC4]
                border border-white/30
                text-white
                "
                value={generalSpace}
                onChange={e =>
                  setGeneralSpace(
                    e.target.value === "" ? "" : Number(e.target.value)
                  )
                }
              />
            </>
          )}

          {divisionType === "seats" && (
            <>
              <label className="font-semibold">Imagen de Division URL</label>

              <input
                className="
        w-full
        p-2
        rounded-lg
        bg-[#608CC4]
        border border-white/30
        text-white
        focus:outline-none
        focus:ring-2
        focus:ring-blue-400
      "
                value={divisionImageUrl}
                onChange={e => setDivisionImageUrl(e.target.value)}
              />
            </>
          )}

          <button
            className="
            w-full
            p-3
            rounded-xl
            bg-[#608CC4]
            hover:bg-[#739dd3]
            text-white
            font-semibold
            transition-all
            duration-200
            shadow-md
            hover:shadow-xl
          "
            onClick={finishDivision}
          >
            Finalizar Division
          </button>

          <hr className="border-white/20" />



          {/* 🧱 BLOQUES */}
          <Section
            title="Generar Bloques"
            name="blocks"
            openSection={openSection}
            setOpenSection={setOpenSection}
          >

            <label>Filas</label>

            <input
              className="
              w-full p-2 rounded-lg
              bg-[#608CC4]
              border border-white/30
              text-white
            "
              value={blockRows}
              onChange={e => setBlockRows(e.target.value === "" ? "" : Number(e.target.value))}
            />

            <label>Columnas</label>

            <input
              className="
              w-full p-2 rounded-lg
              bg-[#608CC4]
              border border-white/30
              text-white
            "
              value={blockCols}
              onChange={e => setBlockCols(e.target.value === "" ? "" : Number(e.target.value))}
            />

            <select
              value={orientation}
              onChange={(e) => setOrientation(e.target.value)}
            >
              <option value="horizontal">Horizontal</option>
              <option value="vertical">Vertical</option>
            </select>
            {orientation === "vertical" && (
              <select
                value={verticalDirection}
                onChange={(e) => setVerticalDirection(e.target.value)}
              >
                <option value="topToBottom">1 → 2 → 3</option>
                <option value="bottomToTop">4 → 3 → 2</option>
              </select>
            )}

            <select
              value={seatNumberMode}
              onChange={(e) => setSeatNumberMode(e.target.value)}
            >
              <option value="normal">Normal</option>
              <option value="interleaved">Intercalado</option>
            </select>

          </Section>

          {/* 🔁 FILAS AUTO */}
          <Section
            title="Filas Automáticas"
            name="rows"
            openSection={openSection}
            setOpenSection={setOpenSection}
          >

            <label>Fila Inicial</label>

            <input
              className="
              w-full p-2 rounded-lg
              bg-[#608CC4]
              border border-white/30
              text-white
            "
              value={rowStart}
              onChange={e => setRowStart(Number(e.target.value))}
            />

            <label>Fila Final</label>

            <input
              className="
              w-full p-2 rounded-lg
              bg-[#608CC4]
              border border-white/30
              text-white
            "
              value={rowEnd}
              onChange={e => setRowEnd(Number(e.target.value))}
            />

            <label>Asientos por Fila</label>

            <input
              className="
              w-full p-2 rounded-lg
              bg-[#608CC4]
              border border-white/30
              text-white
            "
              value={seatsPerRow}
              onChange={e => setSeatsPerRow(Number(e.target.value))}
            />

            <select
              value={rowsOrientation}
              onChange={(e) => setRowsOrientation(e.target.value)}
            >
              <option value="horizontal">Horizontal</option>
              <option value="vertical">Vertical</option>
            </select>

            {rowsOrientation === "vertical" && (
              <select
                value={rowsVerticalDirection}
                onChange={(e) => setRowsVerticalDirection(e.target.value)}
              >
                <option value="topToBottom">1 → 2 → 3</option>
                <option value="bottomToTop">4 → 3 → 2</option>
              </select>
            )}

            <select
              value={seatNumberMode}
              onChange={(e) => setSeatNumberMode(e.target.value)}
            >
              <option value="normal">Normal</option>
              <option value="interleaved">Intercalado</option>
            </select>

          </Section>


          {/* BOTONES */}
          <button className="
            w-full
            p-3
            rounded-xl
            bg-[#608CC4]
            hover:bg-[#739dd3]
            text-white
            font-semibold
            transition-all
            duration-200
            shadow-md
          " onClick={clearCurrentDivision}>
            Borrar los asientos actuales
          </button>

          <button
            className="
            w-full
            p-3
            rounded-xl
            bg-[#608CC4]
            hover:bg-[#739dd3]
            text-white
            font-semibold
            transition-all
            duration-200
            shadow-md
          "
            onClick={generateRows}
          >
            Generar Filas
          </button>

          <button
            className="
            w-full
            p-3
            rounded-xl
            bg-blue-600
            hover:bg-blue-500
            text-white
            font-bold
            transition-all
            duration-200
            shadow-lg
          "
            onClick={handleCreateTemplate}
          >
            Guardar Template
          </button>

          <div
            className="
            bg-[#608CC4]/40
            border border-white/20
            p-3
            text-xs
            rounded-xl
            text-white
            backdrop-blur-md
            leading-5
          "
          >
            <b>Controles:</b><br />
            • Click → Agregar asiento<br />
            • SHIFT → Crear Fila<br />
            • CTRL + click → crear Bloque<br />
            • ALT + drag → mover fila<br />
            • Ruedita → zoom<br />

          </div>

        </div>

        {/* MAP */}

        <div
          ref={containerRef}
          className="
          w-full
          md:flex-1
          border border-white/20
          rounded-2xl
          bg-[#1d3f6e]
          relative
          overflow-hidden
          shadow-2xl
        "
          onMouseDown={handleMouseDown}
          onMouseMove={handleMouseMove}
          onMouseUp={handleMouseUp}
          onClick={handleMapClick}
        >

          {divisionImageUrl && (

            <div
              style={{
                transform: `translate(${pan.x}px,${pan.y}px) scale(${zoomLevel})`,
                transformOrigin: "top left",
                position: "relative",
                display: "inline-block"
              }}
            >
              <img
                ref={imageRef}
                src={divisionImageUrl}
                alt="map"
                draggable={false}
                style={{
                  display: "block",
                  maxWidth: "none",
                  width: "auto",
                  height: "auto",
                  userSelect: "none",
                  pointerEvents: "none"
                }}
              />

              {draftSeats.map((seat, i) => (

                <div
                  key={`draft-${i}`}
                  style={{
                    position: "absolute",
                    left: `${seat.x * 100}%`,
                    top: `${seat.y * 100}%`,

                    width: "18px",
                    height: "18px",
                    minWidth: "18px",
                    minHeight: "18px",
                    boxSizing: "border-box",
                    overflow: "hidden",
                    fontSize: "8px",
                    lineHeight: "18px",
                    background: "#9ca3af",
                    opacity: 0.7,

                    color: "white",

                    fontSize: "9px",
                    fontWeight: "bold",

                    borderRadius: "50%",

                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",

                    transform: "translate(-50%,-50%)",

                    border: "1px solid rgba(255,255,255,0.35)",

                    pointerEvents: "none"
                  }}
                >
                  {seat.id}
                </div>

              ))}

              {currentSeats.map((seat, i) => (

                <React.Fragment key={i}>

                  <div

                    onMouseDown={(e) => {
                      e.stopPropagation()

                      if (e.button !== 0) return

                      setDraggingSeat(i)

                      setDragStart({
                        mouseX: seat.x,
                        mouseY: seat.y,
                        seats: currentSeats.map(s => ({ ...s }))
                      })
                    }}

                    onClick={(e) => e.stopPropagation()}

                    onContextMenu={(e) => {
                      e.preventDefault()
                      e.stopPropagation()
                      handleDeleteSeat(i, e)
                    }}

                    style={{
                      position: "absolute",
                      left: `${seat.x * 100}%`,
                      top: `${seat.y * 100}%`,

                      width: "18px",
                      height: "18px",
                      minWidth: "18px",
                      minHeight: "18px",
                      boxSizing: "border-box",
                      overflow: "hidden",
                      fontSize: "8px",
                      lineHeight: "18px",
                      boxSizing: "border-box",

                      background: getDivisionColor(seat.division),
                      color: "white",

                      fontSize: "9px",
                      fontWeight: "bold",

                      borderRadius: "50%",

                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",

                      transform: "translate(-50%,-50%)",

                      cursor: "pointer",

                      border: "1px solid rgba(255,255,255,0.35)",

                      boxShadow: "0 2px 6px rgba(0,0,0,0.35)",

                      userSelect: "none"
                    }}
                  >
                    {seat.id}
                  </div>

                  {/* TEXTO FILA */}
                  {seat.id === 1 && (
                    <div
                      style={{
                        position: "absolute",
                        left: `${seat.x * 100}%`,
                        top: `${seat.y * 100}%`,

                        // 👇 ACA
                        transform:
                          rowsOrientation === "horizontal"
                            ? "translate(-50%, 20%)"
                            : "translate(20%, -50%)",

                        color: "white",
                        fontSize: "12px",
                        fontWeight: "bold",

                        textShadow: "0 0 4px black",

                        pointerEvents: "none"
                      }}
                    >
                      Fila {seat.row}
                    </div>
                  )}

                </React.Fragment>

              ))}

            </div>

          )}

        </div>

      </div>

    </div>
  )



}

export default CreateZone
